export enum TransactionsTypesEnum {
  Pix = 'pix'
}
